import { DateTime } from "luxon";
import { AbstractControl, FormArray, FormControl, FormGroup } from "@angular/forms";

export function round(value: number, decimals: number = 0) {
  return +value.toFixed(decimals);
}

export function getDateTime(value?: Date | string): DateTime {
  if (!value) {
    return DateTime.now();
  }
  if (value instanceof Date) {
    return DateTime.fromJSDate(value);
  }
  return DateTime.fromISO(value);
}

export function logFormStatusAndErrors(form: AbstractControl, indent: string = ""): void {
  if (form instanceof FormGroup) {
    console.log(indent, form.status, form.errors);
    Object.keys(form.controls).forEach((key) => {
      console.log(indent, key);
      logFormStatusAndErrors(form.controls[key], indent + "  ");
    });
  } else if (form instanceof FormArray) {
    console.log(indent, form.status, form.errors);
    form.controls.forEach((control, index) => {
      console.log(indent + "  Index:", index);
      logFormStatusAndErrors(control, indent + "  ");
    });
  } else if (form instanceof FormControl) {
    console.log(indent, form.status, form.errors);
  }
}
